module.exports = __webpack_public_path__ + "static/img/anli7.8406e79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli/anli7.jpg
// module id = 83Gw
// module chunks = 1